<div id="defectTypesChart"></div>
